import React from 'react';

import { makeStyles } from 'tss-react/mui';

import { Typography } from '@hbf/dsl';

const useStyles = makeStyles()(theme => ({
  root: {
    color: theme.palette.common.white,
    padding: theme.spacing(0.5, 1),
  },
}));

interface Props {
  total: number;
  index: number;
}

const SlideIndex: React.FC<Props> = ({ total, index }) => {
  const { classes } = useStyles();

  return (
    <Typography.Caption
      className={classes.root}
      data-test-locator="gallery-slide-index"
    >
      {`${index + 1} / ${total}`}
    </Typography.Caption>
  );
};

export { SlideIndex };
